import PropTypes from 'prop-types'

import * as Sc from './ModalDeprecated.style'

const ModalDeprecated = ({ children, open }) => (
  <Sc.Container data-testid='overlay' open={open}>
    {children}
  </Sc.Container>
)

ModalDeprecated.propTypes = {
  children: PropTypes.node.isRequired,
  open: PropTypes.bool.isRequired,
}

export default ModalDeprecated
